import Nav from '../../Global/Nav.vue'
export default {
  name: 'DeepMails',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'deepMailsTask',
      // activeName: 'screenDomains',
      uploadApi: this.$axios.defaults.baseURL + 'excel/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      colors: [
        { color: '#1989fa', percentage: 10 },
        { color: '#19bafa', percentage: 20 },
        { color: '#19eefa', percentage: 30 },
        { color: '#19fabe', percentage: 40 },
        { color: '#19fa7f', percentage: 50 },
        { color: '#25fa19', percentage: 60 },
        { color: '#97fa19', percentage: 70 },
        { color: '#8619fa', percentage: 80 },
        { color: '#fa7819', percentage: 90 },
        { color: '#fa1919', percentage: 100 }
      ],
      taskFileList: [],
      taskKeywords: '',
      taskSize: 10,
      taskCurrentPage: 1,
      taskTotal: 0,
      tableLoading: false,
      deepEmailsTaskList: [],
      deepMailsTaskLoading: false,
      createTaskVisable: false,
      createTaskData: [],
      createTaskForm: {
        task_name: '',
        type: 'DEEPEMAILS'
      },
      createTaskRules: {
        task_name: [
          { required: true, message: '任务名称不能为空', trigger: 'commit' }
        ]
      },
      tradeDataTaskFileList: [],
      tradeDataTaskKeywords: '',
      tradeDataTaskSize: 10,
      tradeDataTaskCurrentPage: 1,
      tradeDataTaskTotal: 0,
      tradeDataTaskList: [],
      tradeDataTaskLoading: false,
      createTradeDataTaskVisable: false,
      createTradeDataTaskData: [],
      createTradeDataTaskForm: {
        task_name: '',
        type: 'TRADEENTERPRISE'
      },
      createTradeDataTaskRules: {
        task_name: [
          { required: true, message: '任务名称不能为空', trigger: 'commit' }
        ]
      },
      recycleList: [],
      recycleKeywords: '',
      recycleTotal: 0,
      recycleSize: 10,
      recycleCurrentPage: 1,
      screenContactorsKeywords: '',
      screenContactorsLoading: false,
      screenContactorsList: [],
      screenContactorsTaskTotal: 0,
      screenContactorsTaskSize: 10,
      screenContactorsTaskPage: 1,
      screen_contactors_default_keywords: '',
      createScreenContactorsTaskLoading: false,
      createScreenContactorsTaskVisable: false,
      createScreenContactorsTaskForm: {
        task_name: '',
        file_list: [],
        extra_keywords: null,
        extra_keywords_priority: '优先'
      },
      createScreenContactorsTaskRules: {},
      screenContactorsTaskFileList: [],
      screenContactorsTaskLoading: false,
      // 找买家
      findBuyersKeywords: '',
      findBuyersList: [],
      findBuyersTotal: 0,
      findBuyersSize: 10,
      findBuyersCurrentPage: 1,
      createFindBuyersVisable: false,
      createFindBuyersForm: {
        task_name: '',
        type: 'FINDBUYERS',
        strict: true
      },
      createFindBuyersRules: {},
      findBuyersFileList: [],
      findBuyersLoading: false,
      // 邮箱验证
      emailCheckKeywords: '',
      emailCheckList: [],
      emailCheckTotal: 0,
      emailCheckSize: 10,
      emailCheckCurrentPage: 1,
      createEmailCheckVisable: false,
      createEmailCheckForm: {
        task_name: '',
        type: 'EMAILCHECK',
        email_server_id: null
      },
      createEmailCheckRules: {},
      emailCheckFileList: [],
      emailCheckLoading: false,
      createEmailCheckFullLoading: false,
      createEmailCheckLoading: false,
      emailServers: [],

      domainsKeywords: '',
      domainsLoading: false,
      domainsList: [],
      domainsTotal: 0,
      domainsSize: 100,
      domainsCurrentPage: 1,
      uploadDomainsDataVisible: false,
      uploadDomainsDataForm: {
        uploadDomainsFileList: []
      },
      uploadDomainsDataLoading: false,
      doScreenDomainsVisible: false,
      doScreenDomainsForm: {
        doScreenDomainsFileList: []
      },
      doScreenDomainsPercentage: 0,
      doScreenDomainsResult: {
        download_storage_path: '',
        download_file: ''
      },
      screenDomainsId: ''
    }
  },
  mounted() {
    this.queryDeepEmailsTaskList();
    this.intervals = setInterval(() => {
      if (this.activeName === 'deepMailsTask') {
        this.queryDeepEmailsTaskList(false, true);
      } else if (this.activeName === 'tradeDataTask') {
        this.queryTradeDataTaskList(false, true);
      } else if (this.activeName === 'findBuyers') {
        this.queryFindBuyersList(false, true);
      } else if (this.activeName === 'emailCheck') {
        this.queryEmailCheckList(false, true);
      }
    }, 10000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'deepMailsTask':
          this.queryDeepEmailsTaskList();
          break;
        case 'tradeDataTask':
          this.queryTradeDataTaskList();
          break;
        case 'screenContactors':
          this.queryScreenContactorsList();
          this.getScreenContactorsOptions();
          break;
        case 'findBuyers':
          this.queryFindBuyersList();
          break;
        case 'emailCheck':
          this.queryEmailCheckList();
          break;
        case 'screenDomains':
          this.queryDomainsList();
          break;
        case 'recycle':
          this.queryRecycleList();
          break;
      }
    },
    queryDeepEmailsTaskList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.taskCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.taskKeywords,
          size: this.taskSize,
          page: current_page,
          type: 'DEEPEMAILS'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.deepEmailsTaskList = response.data.data.data
          this.taskTotal = response.data.data.total
        }
      });
    },
    changeTaskSize(val) {
      this.taskSize = val;
      this.queryDeepEmailsTaskList();
    },
    currentTaskChange(val) {
      this.taskCurrentPage = val;
      this.queryDeepEmailsTaskList();
    },
    createTask() {
      this.createTaskVisable = true
    },
    taskUploadSuccess(response) {
      this.taskFileList = [];
      if (response.code === 200) {
        this.taskFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateTask() {
      this.taskFileList = [];
      this.createTaskVisable = false
    },
    saveCreateTask() {
      if (this.taskFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createTaskForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在保存, 请稍候',
            'type': 'info'
          })
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createTaskForm.task_name,
            file_name: this.taskFileList[0].name,
            file_path: this.taskFileList[0].url,
            type: this.createTaskForm.type
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createTaskVisable = false;
              this.createTaskForm.task_name = '';
              this.taskFileList = [];
              this.queryDeepEmailsTaskList();
            }
          })
        }
      })
    },
    deepEmailsTaskDel(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/fumeng/delete_task', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryDeepEmailsTaskList();
            this.queryTradeDataTaskList();
            this.queryFindBuyersList();
            this.queryEmailCheckList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    queryTradeDataTaskList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.tradeDataTaskCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.tradeDataTaskKeywords,
          size: this.tradeDataTaskSize,
          page: current_page,
          type: 'TRADEENTERPRISE'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.tradeDataTaskList = response.data.data.data
          this.tradeDataTaskTotal = response.data.data.total
        }
      });
    },
    changeTradeDataTaskSize(val) {
      this.tradeDataTaskSize = val;
      this.queryTradeDataTaskList();
    },
    currentTradeDataTaskChange(val) {
      this.tradeDataTaskCurrentPage = val;
      this.queryTradeDataTaskList();
    },
    createTradeDataTask() {
      this.createTradeDataTaskVisable = true
    },
    tradeDataTaskUploadSuccess(response) {
      this.tradeDataTaskFileList = [];
      if (response.code === 200) {
        this.tradeDataTaskFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateTradeDataTask() {
      this.tradeDataTaskFileList = [];
      this.createTradeDataTaskVisable = false
    },
    saveCreateTradeDataTask() {
      if (this.tradeDataTaskFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createTradeDataTaskForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在保存, 请稍候',
            'type': 'info'
          })
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createTradeDataTaskForm.task_name,
            file_name: this.tradeDataTaskFileList[0].name,
            file_path: this.tradeDataTaskFileList[0].url,
            type: this.createTradeDataTaskForm.type
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createTradeDataTaskVisable = false;
              this.createTradeDataTaskForm.task_name = '';
              this.tradeDataTaskFileList = [];
              this.queryTradeDataTaskList();
            }
          })
        }
      })
    },
    taskFileDownload(row) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + row.file_path + '&savename=' + row.file_name;
    },
    resultFileDownload(row) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + row.download_storage_path + '&savename=' + row.download_file;
    },
    deepTradeDataTaskDel(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('email/fumeng/delete_task', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.queryTradeDataTaskList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    taskPausedToggle(row) {
      this.$axios.post('email/fumeng/task_toggle_status', {
        id: row.id,
        paused: row.paused ? 0 : 1
      }).then((response) => {
        this.queryTradeDataTaskList();
        this.queryFindBuyersList();
      })
    },
    queryRecycleList(iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      this.$axios.get(`center/data/recycle_list`, {
        params: {
          keywords: this.recycleKeywords,
          size: this.recycleSize,
          page: this.recycleCurrentPage,
          module: 'FUMAMX'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.recycleList = response.data.data.data
          this.recycleTotal = response.data.data.total
        }
      });
    },
    changeRecycleSize(val) {
      this.recycleSize = val;
      this.queryRecycleList();
    },
    currentRecycleChange(val) {
      this.recycleCurrentPage = val;
      this.queryRecycleList();
    },
    recycleRestore(row) {
      this.$confirm('确定还原吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_restore', {
          id: row.id,
          module: 'FUMAMX'
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.queryRecycleList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    recycleDel(row) {
      this.$confirm('此操作不可恢复, 确定吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$axios.post('center/data/recycle_delete', {
          id: row.id,
          module: 'FUMAMX'
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.queryRecycleList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    queryScreenContactorsList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.screenContactorsTaskPage;
      this.$axios.get(`center/tools/screen_contactors/list`, {
        params: {
          keywords: this.screenContactorsKeywords,
          size: this.screenContactorsTaskSize,
          page: current_page
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.screenContactorsList = response.data.data.data
          this.screenContactorsTaskTotal = response.data.data.total
        }
      });
    },
    changeScreenContactorsTaskSize(val) {
      this.screenContactorsTaskSize = val;
      this.queryScreenContactorsList();
    },
    currentScreenContactorsTaskChange(val) {
      this.screenContactorsTaskPage = val;
      this.queryScreenContactorsList();
    },
    screenContactorsTaskUploadSuccess(response) {
      this.createScreenContactorsTaskForm.file_list = [];
      if (response.code === 200) {
        this.createScreenContactorsTaskForm.file_list.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    getScreenContactorsOptions() {
      this.$axios.get(`center/tools/screen_contactors/options?type=default_keywords`).then((response) => {
        if (response.data.code === 200) {
          this.screen_contactors_default_keywords = response.data.data.join("<br>")
        }
      });
    },
    createScreenContactors() {
      this.createScreenContactorsTaskVisable = true;
    },
    cancelCreateScreenContactorsTask() {
      this.createScreenContactorsTaskVisable = false;
      this.createScreenContactorsTaskForm = {
        task_name: '',
        file_list: [],
        extra_keywords: null,
        extra_keywords_priority: '优先'
      };
    },
    saveCreateScreenContactorsTask() {
      this.createScreenContactorsTaskLoading = true;
      this.$axios.post('center/tools/screen_contactors/create', this.createScreenContactorsTaskForm).then((response) => {
        this.createScreenContactorsTaskLoading = false;
        if (response.data.code === 200) {
          this.$notify({
            title: '添加成功',
            message: '添加成功',
            type: 'success'
          });
          this.createScreenContactorsTaskVisable = false;
          this.createScreenContactorsTaskForm = {
            task_name: '',
            file_list: [],
            extra_keywords: null,
            extra_keywords_priority: '优先'
          };
          this.queryScreenContactorsList();
        }
      })
    },
    screenContactorsTaskDel(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('center/tools/screen_contactors/delete', {
          id: row.id
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '删除成功',
              message: '删除成功',
              type: 'success'
            });
            this.queryScreenContactorsList();
          }
        })
      })
    },
    createFindBuyersTask() {
      this.createFindBuyersVisable = true
    },
    queryFindBuyersList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.findBuyersCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.findBuyersKeywords,
          size: this.findBuyersSize,
          page: current_page,
          type: 'FINDBUYERS'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.findBuyersList = response.data.data.data
          this.findBuyersTotal = response.data.data.total
        }
      });
    },
    changeFindBuyersSize(val) {
      this.findBuyersSize = val;
      this.queryFindBuyersList();
    },
    currentFindBuyersChange(val) {
      this.findBuyersCurrentPage = val;
      this.queryFindBuyersList();
    },
    createFindBuyers() {
      this.findBuyersVisable = true
    },
    findBuyersUploadSuccess(response) {
      this.findBuyersFileList = [];
      if (response.code === 200) {
        this.findBuyersFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateFindBuyers() {
      this.findBuyersFileList = [];
      this.createFindBuyersVisable = false
    },
    saveCreateFindBuyers() {
      if (this.findBuyersFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createFindBuyersForm.validate(valid => {
        if (valid) {
          this.$notify({
            'title': '提示',
            'message': '正在保存, 请稍候',
            'type': 'info'
          })
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createFindBuyersForm.task_name,
            file_name: this.findBuyersFileList[0].name,
            file_path: this.findBuyersFileList[0].url,
            type: this.createFindBuyersForm.type,
            strict: this.createFindBuyersForm.strict
          }).then((response) => {
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createFindBuyersVisable = false;
              this.createFindBuyersForm.task_name = '';
              this.findBuyersFileList = [];
              this.queryFindBuyersList();
            }
          })
        }
      })
    },
    createEmailCheckTask() {
      this.createEmailCheckLoading = true;
      this.$axios.get(`center/data/email_servers`).then((response) => {
        this.createEmailCheckLoading = false;
        if (response.data.code === 200) {
          this.emailServers = response.data.data;
        }
      });
      setTimeout(() => {
        this.createEmailCheckVisable = true
      }, 0);
    },
    queryEmailCheckList(search = false, iv = false) {
      if (iv === false) {
        this.tableLoading = true;
      }
      let current_page = search === true ? 1 : this.emailCheckCurrentPage;
      this.$axios.get(`email/fumeng/task_list`, {
        params: {
          keywords: this.emailCheckKeywords,
          size: this.emailCheckSize,
          page: current_page,
          type: 'EMAILCHECK'
        }
      }).then((response) => {
        this.tableLoading = false;
        if (response.data.code === 200) {
          this.emailCheckList = response.data.data.data
          this.emailCheckTotal = response.data.data.total
        }
      });
    },
    changeEmailCheckSize(val) {
      this.emailCheckSize = val;
      this.queryEmailCheckList();
    },
    currentEmailCheckChange(val) {
      this.emailCheckCurrentPage = val;
      this.queryEmailCheckList();
    },
    createEmailCheck() {
      this.createEmailCheckVisable = true
    },
    emailCheckUploadSuccess(response) {
      this.emailCheckFileList = [];
      if (response.code === 200) {
        this.emailCheckFileList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    cancelCreateEmailCheck() {
      this.emailCheckFileList = [];
      this.createEmailCheckForm = {
        task_name: '',
        type: 'EMAILCHECK',
        email_server_id: null
      };
      this.createEmailCheckVisable = false
    },
    saveCreateEmailCheck() {
      if (this.emailCheckFileList.length < 1) {
        this.$notify({
          title: 'failed',
          message: '请选择文件',
          type: 'warning'
        })
        return false;
      }
      this.$refs.createEmailCheckForm.validate(valid => {
        if (valid) {
          this.createEmailCheckFullLoading = true;
          this.$axios.post('email/fumeng/create_task', {
            task_name: this.createEmailCheckForm.task_name,
            file_name: this.emailCheckFileList[0].name,
            file_path: this.emailCheckFileList[0].url,
            type: this.createEmailCheckForm.type,
            email_server_id: this.createEmailCheckForm.email_server_id
          }).then((response) => {
            this.createEmailCheckFullLoading = false;
            if (response.data.code === 200) {
              this.$notify({
                'title': 'success',
                'message': '创建成功',
                'type': 'success'
              })
              this.createEmailCheckVisable = false;
              this.createEmailCheckForm = {
                task_name: '',
                type: 'EMAILCHECK',
                email_server_id: null
              };
              this.emailCheckFileList = [];
              this.queryEmailCheckList();
            }
          })
        }
      })
    },
    domainsDataUploadSuccess(file, fileList) {
      this.uploadDomainsDataForm.uploadDomainsFileList = fileList;
    },
    uploadDomainsData() {
      this.uploadDomainsDataVisible = true;
    },
    saveUploadDomainsData() {
      this.uploadDomainsDataLoading = true;
      this.$axios.post('center/tools/screen_domains/upload', this.uploadDomainsDataForm).then((response) => {
        this.uploadDomainsDataLoading = false;
        if (response.data.code === 200) {
          this.$notify({
            title: 'success',
            message: '上传成功, 本次总计新增' + response.data.data + '条',
            type: 'success',
            duration: 0
          });
          this.uploadDomainsDataForm = {
            uploadDomainsFileList: []
          }
          this.uploadDomainsDataVisible = false;
          this.queryDomainsList();
        }
      })
    },
    queryDomainsList(search = false) {
      let current_page = search === true ? 1 : this.domainsCurrentPage;
      this.$axios.get(`center/tools/screen_domains/list`, {
        params: {
          keywords: this.domainsKeywords,
          size: this.domainsSize,
          page: current_page
        }
      }).then((response) => {
        this.domainsLoading = false;
        if (response.data.code === 200) {
          this.domainsList = response.data.data.data
          this.domainsTotal = response.data.data.total
        }
      });
    },
    createScreenDomainsTask() {
      this.doScreenDomainsVisible = true;
    },
    doScreenDomainsUploadSuccess(file, fileList) {
      this.doScreenDomainsForm.doScreenDomainsFileList = fileList;
    },
    startScreenDomains() {
      this.$axios.post(`center/tools/screen_domains/start`, this.doScreenDomainsForm).then((response) => {
        if (response.data.code === 200) {
          this.screenDomainsId = response.data.data;
          this.$notify({
            title: 'success',
            message: '上传成功 请点击开始',
            type: 'success'
          });
        } else {
          this.$notify({
            title: '操作失败',
            message: response.data.data,
            type: 'warning'
          });
        }
      })
    },
    doStartScreenDomains() {
      this.queryDoStartScreenProgress();
      this.$notify({
        title: 'success',
        message: '操作成功 请勿关闭或刷新页面',
        type: 'success',
        duration: 0
      });
      this.$axios.post(`center/tools/screen_domains/real_start`, {
        id: this.screenDomainsId
      })
    },
    queryDoStartScreenProgress() {
      this.$axios.get(`center/tools/screen_domains/progress?id=` + this.screenDomainsId).then((response) => {
        if (response.data.code === 200) {
          if (!isNaN(response.data.data.progress)) {
            this.doScreenDomainsPercentage = response.data.data.progress;
            var screenInterval = setTimeout(() => {
              this.queryDoStartScreenProgress(true)
            }, 500)
          } else {
            this.doScreenDomainsPercentage = 100;
            this.doScreenDomainsResult = response.data.data;
            clearTimeout(screenInterval);
          }
        }
      })
    },
    changeDomainsSize(val) {
      this.domainsListSize = val;
      this.queryDomainsList();
    },
    currentDomainsChange(val) {
      this.domainsCurrentPage = val;
      this.queryDomainsList();
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/DeepEmails/script.js